var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "106px",
    height: "118px",
    viewBox: "0 0 106 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F5B8484B-6FB4-4541-8CB4-AB2A77906EA7@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.478,117.26 C76.488038,117.26 98.384,95.364038 98.384,68.354 C98.384,63.4974515 103.148109,64.3699318 104.39,57.2 C106.599537,44.4434603 105.179128,22.7006676 99.519168,15.303961 C98.6902514,14.220693 82.3876804,6.41797726 81.5011809,5.64931789 C72.9213319,-1.79003366 61.7254112,0.572 49.478,0.572 C31.7555724,0.572 12.8028705,4.85070814 4.22451069,18.963508 C-0.271062168,26.359458 0.572,59.0663896 0.572,68.354 C0.572,95.364038 22.467962,117.26 49.478,117.26 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Primary-Navigation-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing",
    transform: "translate(-188.000000, -7085.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(106.000000, 7085.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder___library_book_shelf_archive_3371910-copy-4",
    transform: "translate(82.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#EDEFF3",
    fillRule: "nonzero",
    cx: 49.478,
    cy: 68.354,
    r: 48.906
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    opacity: 0.4,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder___help_person_support_5220818",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.288000, 17.732000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.232,90.948 L6.864,90.948 L6.864,34.64175 C6.864,32.5771875 8.5488,30.888 10.608,30.888 L85.488,30.888 C87.5472,30.888 89.232,32.5771875 89.232,34.64175 L89.232,90.948 Z",
    id: "Path",
    fill: "#DBE2EA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.68,85.8 C64.68,87.9572571 63.0168,89.7222857 60.984,89.7222857 L35.112,89.7222857 C33.0792,89.7222857 31.416,87.9572571 31.416,85.8 L0,85.8 L0,95.6057143 C0,97.7629714 1.6632,99.528 3.696,99.528 L92.4,99.528 C94.4328,99.528 96.096,97.7629714 96.096,95.6057143 L96.096,85.8 L64.68,85.8 Z",
    id: "Path",
    fill: "#000F38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3.432000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07303782,31.0955674 L2.07303782,24.0472388 C2.07303782,14.5112648 8.49945508,5.80450591 17.8281253,3.5241643 C31.5101749,0.414607565 43.5337943,10.5724929 43.5337943,23.6326312 L43.5337943,31.0955674",
    id: "Path",
    fill: "#FF4D5B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 4.14607565,
    cy: 31.0955674,
    r: 4.14607565
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 41.4607565,
    cy: 31.0955674,
    r: 4.14607565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14607565,23.839935 C4.14607565,12.0236194 14.9258723,2.90225295 27.1567955,5.59720212 C35.6562506,7.46293617 41.4607565,15.5477837 41.4607565,24.2545425 L41.4607565,32.7539976 C41.4607565,41.4607565 35.6562506,49.3383002 27.1567955,51.411338 C14.9258723,54.1062872 4.14607565,44.9849208 4.14607565,33.1686052 L4.14607565,23.839935 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3877187,11.6090118 C39.3877187,10.9871005 39.1804149,10.3651891 38.9731111,9.74327777 C37.9365922,6.21911347 34.2051241,0.207303782 23.839935,0.414607565 C9.32867021,0.82921513 1.45112648,7.46293617 1.45112648,7.46293617 L5.59720212,13.4747459 C5.59720212,13.4747459 8.70675886,17.2062139 11.1944042,16.9989102 C12.2309232,16.9989102 13.2674421,16.5843026 14.0966572,15.9623912 C15.1331761,17.8281253 17.2062139,18.8646442 19.2792518,18.8646442 C20.5230745,18.8646442 21.7668972,18.2427329 22.5961123,17.4135177 C24.2545425,20.1084669 27.3640993,21.7668972 30.6809598,21.5595934 C35.6562506,21.3522896 39.5950224,16.9989102 39.1804149,12.0236194 C39.3877187,12.0236194 39.3877187,12.0236194 39.3877187,11.6090118 Z",
    id: "Path",
    fill: "#FF4D5B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42641725,26.9494917 C6.42641725,26.9494917 5.38989834,15.5477837 22.8034161,15.5477837 C40.2169338,15.5477837 39.3877187,26.9494917 39.3877187,26.9494917 L41.4607565,26.9494917 L43.5337943,22.8034161 L37.3146808,10.3651891 L26.5348841,5.80450591 L13.6820496,7.25563238 L5.38989834,13.4747459 L2.69494917,21.3522896 L3.31686052,26.7421879 L6.42641725,26.7421879 L6.42641725,26.9494917 Z",
    id: "Path",
    fill: "#FF4D5B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8152258,39.3877187 C29.4371371,39.3877187 29.8517447,40.00963 29.8517447,40.6315414 C29.2298333,43.9484019 26.3275804,46.643351 22.8034161,46.643351 C19.2792518,46.643351 16.3769988,44.1557057 15.7550875,40.6315414 C15.5477837,40.00963 16.169695,39.3877187 16.7916064,39.3877187 L28.8152258,39.3877187 Z",
    id: "Path",
    fill: "#D9DCE1",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.344,48.048 L64.5757895,41.756 L95.3734737,41.756 C97.6584632,41.756 99.528,39.8684 99.528,37.5613333 L99.528,12.7746667 C99.528,10.4676 97.6584632,8.58 95.3734737,8.58 L62.4985263,8.58 C60.2135368,8.58 58.344,10.4676 58.344,12.7746667 L58.344,48.048 Z",
    id: "Path",
    fill: "#FF4D5B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(73.788000, 17.160000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 4.33453363,
    cy: 15.5471441,
    r: 1.88457984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,4.2396651 C0,1.60125332 2.44995379,-0.471784504 5.46528154,0.0935894484 C6.97294541,0.470505416 8.2921513,1.7897113 8.66906726,3.29737518 C9.23444122,6.12424494 7.16140339,8.57419873 4.33453363,8.57419873 L4.33453363,11.7779845",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3.76915968
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.10cba9a2a43f563489b5940401f1d25c.svg";
export { ForwardRef as ReactComponent };